import { render, staticRenderFns } from "./select-course-type-modal.vue?vue&type=template&id=2b595d5f&scoped=true"
import script from "./select-course-type-modal.vue?vue&type=script&lang=js"
export * from "./select-course-type-modal.vue?vue&type=script&lang=js"
import style0 from "./select-course-type-modal.vue?vue&type=style&index=0&id=2b595d5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b595d5f",
  null
  
)

export default component.exports